import {
  enUS,
  zhCN,
  fr,
  de,
  es,
  it,
  ja,
  ko,
  ru,
  ptBR,
  nl,
  sv,
  fi,
  pl,
  tr,
  ar,
  he,
  id,
  vi,
  th,
  hi,
  ms,
  uk,
  cs,
  hu,
  ro,
  sk,
  bg,
  da,
  hr,
  sr,
  lt,
  sl,
  nb,
  et,
  lv,
} from 'date-fns/locale';

const locales = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'fr-FR': fr,
  'de-DE': de,
  'es-ES': es,
  'it-IT': it,
  'ja-JP': ja,
  'ko-KR': ko,
  'ru-RU': ru,
  'pt-BR': ptBR,
  'nl-NL': nl,
  'sv-SE': sv,
  'fi-FI': fi,
  'pl-PL': pl,
  'tr-TR': tr,
  'ar-SA': ar,
  'he-IL': he,
  'id-ID': id,
  'vi-VN': vi,
  'th-TH': th,
  'hi-IN': hi,
  'ms-MY': ms,
  'uk-UA': uk,
  'cs-CZ': cs,
  'hu-HU': hu,
  'ro-RO': ro,
  'sk-SK': sk,
  'bg-BG': bg,
  'da-DK': da,
  'hr-HR': hr,
  'sr-RS': sr,
  'lt-LT': lt,
  'sl-SI': sl,
  'nb-NO': nb,
  'et-EE': et,
  'lv-LV': lv,
};

export function getLocale() {
  const { locale } = Intl.DateTimeFormat().resolvedOptions();
  return locales[locale as keyof typeof locales] || enUS;
}
